import React, { Component } from 'react';
import { PaddedSection } from '../../atoms';

import './styles.css';

/**
 * A template for the contact us section.
 *
 * @typedef {Object} Props
 * @prop {String} address
 * @prop {String} mapHeading
 * @prop {String} mapQuery
 *
 * @augments {Component<Props>}
 */
export default class ContactUs extends Component {

	render () {

		return (
			<PaddedSection className='ContactUs'>
				<div>
					{this.props.children}
				</div>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/ContactUs/ContactUs.js